<div class="mx-auto max-w-7xl mt-50 px-4 pb-12 sm:px-6 lg:px-8">
  <div class="rounded-lg bg-white px-1 py-6 sm:px-6" style="margin-top: 0px">
    <div class="row">
      <div class="col-md-12 order-md-1 order-sm-2">
        <!-- MAIN CONTENT START -->

        <form [formGroup]="frmZahlung" (ngSubmit)="saveZahlung(true)">
          <mat-tab-group animationDuration="0ms">
            <!-- Tab 1: Bank Transfer Details -->
            <mat-tab label="Bankdaten">
              <div class="step-container d-flex align-items-start flex-column">
                <div class="container-fluid mt-6">
                  <div class="form">
                    <div class="row">
                      <div class="col-12 col-lg-6">
                        <!-- Bank Transfer ID -->
                        <div class="form-group">
                          <label class="form-label" for="bank_transfer_id">Bank Transfer ID</label>
                          <input
                            type="text"
                            class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                            style="background-color: #f8f9fa !important"
                            id="bank_transfer_id"
                            formControlName="bank_transfer_id"
                            readonly />
                        </div>

                        <!-- Amount -->
                        <div class="form-group">
                          <label class="form-label" for="betrag">Betrag *</label>
                          <input
                            type="number"
                            step="0.01"
                            class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                            id="betrag"
                            formControlName="betrag"
                            (change)="onBetragChange()"
                            placeholder="0.00" />
                        </div>

                        <!-- Currency -->
                        <div class="form-group">
                          <label class="form-label" for="currency">Währung</label>
                          <input
                            type="text"
                            class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                            style="background-color: #f8f9fa !important"
                            id="currency"
                            formControlName="currency"
                            readonly />
                        </div>

                        <!-- Valuta Date -->
                        <div class="form-group">
                          <label class="form-label" for="valuta_datum">Valuta Datum *</label>
                          <input
                            type="date"
                            class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                            id="valuta_datum"
                            formControlName="valuta_datum" />
                        </div>

                        <!-- Booking Date -->
                        <div class="form-group">
                          <label class="form-label" for="buchungs_datum">Buchungsdatum</label>
                          <input
                            type="date"
                            class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                            style="background-color: #f8f9fa !important"
                            id="buchungs_datum"
                            formControlName="buchungs_datum"
                            readonly />
                        </div>
                      </div>

                      <div class="col-12 col-lg-6">
                        <!-- Debtor Name -->
                        <div class="form-group">
                          <label class="form-label" for="debtor_name">Einzahler *</label>
                          <input
                            type="text"
                            class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                            id="debtor_name"
                            formControlName="debtor_name"
                            placeholder="Name des Zahlers" />
                        </div>

                        <!-- Debtor IBAN -->
                        <div class="form-group">
                          <label class="form-label" for="debtor_iban">Einzahler IBAN</label>
                          <input
                            type="text"
                            class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                            style="background-color: #f8f9fa !important"
                            id="debtor_iban"
                            formControlName="debtor_iban"
                            readonly />
                        </div>

                        <!-- Creditor Reference -->
                        <div class="form-group">
                          <label class="form-label" for="creditor_reference">Gläubiger Referenz</label>
                          <input
                            type="text"
                            class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                            style="background-color: #f8f9fa !important"
                            id="creditor_reference"
                            formControlName="creditor_reference"
                            readonly />
                        </div>

                        <!-- Purpose Code -->
                        <div class="form-group">
                          <label class="form-label" for="purpose_code">Verwendungszweck</label>
                          <input
                            type="text"
                            class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                            style="background-color: #f8f9fa !important"
                            id="purpose_code"
                            formControlName="purpose_code"
                            readonly />
                        </div>

                        <!-- Import Date -->
                        <div class="form-group">
                          <label class="form-label" for="import_datum">Import Datum</label>
                          <input
                            type="date"
                            class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                            style="background-color: #f8f9fa !important"
                            id="import_datum"
                            formControlName="import_datum"
                            readonly />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mat-tab>

            <!-- Tab 2: Mandate Assignment & Reconciliation -->
            <mat-tab label="Mandat Zuordnung">
              <div class="step-container d-flex align-items-start flex-column">
                <div class="container-fluid mt-6">
                  <div class="form">
                    <!-- Mandat-Suche -->
                    <div class="mb-4 rounded-lg border border-gray-200 bg-gray-50 p-4">
                      <label class="mb-2 block text-sm font-semibold text-gray-700">Mandat suchen &amp; zuordnen</label>
                      <div class="flex flex-col gap-3 sm:flex-row sm:items-end">
                        <div class="flex-1">
                          <input
                            type="text"
                            [(ngModel)]="mandatSearchTerm"
                            [ngModelOptions]="{ standalone: true }"
                            (keyup.enter)="searchMandate()"
                            placeholder="Aktenzeichen / Kennzeichen suchen"
                            class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500" />
                        </div>
                        <button type="button" (click)="searchMandate()"
                                class="inline-flex items-center justify-center gap-1 rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50"
                                [disabled]="isSearchingMandate">
                          <i class="fas fa-search"></i> Suchen
                        </button>
                        <label class="inline-flex items-center gap-2 text-sm text-gray-700 whitespace-nowrap">
                          <input type="checkbox" [(ngModel)]="onlyOpenMandate" [ngModelOptions]="{ standalone: true }"
                                 (change)="searchMandate()"
                                 class="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                          Nur offene/aktive Mandate
                        </label>
                      </div>

                      <!-- Ergebnis-Tabelle -->
                      <div class="mt-3 overflow-x-auto rounded-md border border-gray-200 bg-white">
                        <table class="min-w-full divide-y divide-gray-200 text-sm">
                          <thead class="bg-gray-100">
                            <tr>
                              <th class="px-3 py-2 text-left font-medium text-gray-600">Aktenzeichen</th>
                              <th class="px-3 py-2 text-left font-medium text-gray-600">Kennzeichen</th>
                              <th class="px-3 py-2 text-right font-medium text-gray-600">Betrag</th>
                              <th class="px-3 py-2 text-left font-medium text-gray-600">Tatdatum</th>
                              <th class="px-3 py-2 text-left font-medium text-gray-600">Status</th>
                              <th class="px-3 py-2 text-right font-medium text-gray-600">Aktion</th>
                            </tr>
                          </thead>
                          <tbody class="divide-y divide-gray-100">
                            <tr *ngFor="let m of mandatSearchResults"
                                [class.bg-blue-50]="isMandatSelected(m)">
                              <td class="px-3 py-2 font-medium text-gray-800">{{ m.Md_BelegNr }}</td>
                              <td class="px-3 py-2 text-gray-700">{{ m.Md_Kennzeichen }}</td>
                              <td class="px-3 py-2 text-right text-gray-700">{{ formatCurrency(m.Md_Betrag) }}</td>
                              <td class="px-3 py-2 text-gray-700">{{ formatDate(m.Md_Datum) }}</td>
                              <td class="px-3 py-2">
                                <span class="inline-flex rounded-full px-2 py-0.5 text-xs font-medium"
                                      [ngClass]="getMandatStatusClass(m.Md_Status)">
                                  {{ getMandatStatusLabel(m.Md_Status) }}
                                </span>
                              </td>
                              <td class="px-3 py-2 text-right whitespace-nowrap">
                                <button type="button" (click)="openMandatePreview(m)"
                                        class="mr-2 rounded-md border border-gray-300 px-2 py-1 text-xs text-gray-700 hover:bg-gray-100">
                                  <i class="fas fa-eye"></i> Vorschau
                                </button>
                                <button type="button" (click)="selectMandate(m)"
                                        class="rounded-md bg-green-600 px-2 py-1 text-xs font-medium text-white hover:bg-green-700">
                                  <i class="fas fa-check"></i> Auswählen
                                </button>
                              </td>
                            </tr>
                            <tr *ngIf="mandatSearchResults.length === 0">
                              <td colspan="6" class="px-3 py-4 text-center text-gray-500">
                                Keine Mandate gefunden. Bitte Suchbegriff eingeben und „Suchen" klicken.
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-lg-6">
                        <!-- Aktenzeichen -->
                        <div class="form-group">
                          <label class="form-label" for="aktenzeichen">Aktenzeichen</label>
                          <input
                            type="text"
                            class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                            id="aktenzeichen"
                            formControlName="aktenzeichen"
                            readonly />
                        </div>

                        <!-- Mandate Amount -->
                        <div class="form-group">
                          <label class="form-label" for="mandat_betrag_faellig">Mandat Betrag</label>
                          <input
                            type="number"
                            step="0.01"
                            class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                            id="mandat_betrag_faellig"
                            formControlName="mandat_betrag_faellig"
                            readonly />
                        </div>

                        <!-- Mandate Due Date -->
                        <div class="form-group">
                          <label class="form-label" for="mandat_faelligkeitsdatum">Fälligkeitsdatum</label>
                          <input
                            type="date"
                            class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                            id="mandat_faelligkeitsdatum"
                            formControlName="mandat_faelligkeitsdatum"
                            readonly />
                        </div>

                        <!-- Amount Difference -->
                        <div class="form-group">
                          <label class="form-label" for="betrag_differenz">Betrag Differenz</label>
                          <input
                            type="number"
                            step="0.01"
                            class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                            id="betrag_differenz"
                            formControlName="betrag_differenz"
                            readonly />
                        </div>
                      </div>

                      <div class="col-12 col-lg-6">
                        <!-- Warnung bei kritischem Mandatsstatus -->
                        <div *ngIf="selectedMandat && isMandatWarning(selectedMandat.Md_Status)"
                             class="mb-3 flex items-start gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-800">
                          <i class="fas fa-exclamation-triangle mt-0.5"></i>
                          <span>{{ getMandatWarningText(selectedMandat.Md_Status) }}</span>
                        </div>

                        <!-- Payment Status -->
                        <div class="form-group">
                          <label class="form-label" for="payment_status">Zahlungsstatus *</label>
                          <select formControlName="payment_status" id="payment_status"
                                  class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
                            <option *ngFor="let status of paymentStatusOptions" [value]="status.value">
                              {{ status.label }}
                            </option>
                          </select>
                        </div>

                        <!-- Reconciliation Status -->
                        <div class="form-group">
                          <label class="form-label" for="reconciliation_status">Abgleichstatus *</label>
                          <select formControlName="reconciliation_status" id="reconciliation_status"
                                  class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
                            <option *ngFor="let status of reconciliationStatusOptions" [value]="status.value">
                              {{ status.label }}
                            </option>
                          </select>
                        </div>

                        <!-- Duplicate Flag -->
                        <div class="form-group">
                          <label class="inline-flex items-center gap-2 text-sm text-gray-700">
                            <input type="checkbox" formControlName="is_duplicate"
                                   class="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                            Doppelzahlung
                          </label>
                        </div>

                        <!-- Reversed Flag -->
                        <div class="form-group">
                          <label class="inline-flex items-center gap-2 text-sm text-gray-700">
                            <input type="checkbox" formControlName="is_reversed"
                                   class="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                            Storniert
                          </label>
                        </div>

                        <!-- Action Buttons -->
                        <div class="form-group">
                          <button type="button" class="btn btn-primary me-2" (click)="assignToMandate()" 
                                  [disabled]="!frmZahlung.get('mandat_id')?.value">
                            <i class="fas fa-link"></i> Mandat zuordnen
                          </button>
                          <button type="button" class="btn btn-success" (click)="reconcilePayment()" 
                                  [disabled]="!frmZahlung.get('mandat_id')?.value">
                            <i class="fas fa-check"></i> Abgleichen
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mat-tab>

            <!-- Tab 3: Payment Analysis & History -->
            <mat-tab label="Analyse & Historie">
              <div class="step-container d-flex align-items-start flex-column">
                <div class="container-fluid mt-6">
                  <div class="row">
                    <div class="col-12 col-lg-6">
                      <h5>Zahlungshistorie</h5>
                      <div class="table-responsive" *ngIf="paymentHistory.length > 0">
                        <table class="table table-sm">
                          <thead>
                            <tr>
                              <th>Datum</th>
                              <th>Betrag</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let payment of paymentHistory">
                              <td>{{ formatDate(payment.valuta_datum) }}</td>
                              <td>{{ formatCurrency(payment.betrag) }}</td>
                              <td>
                                <span class="badge" [class]="getPaymentStatusClass(payment.payment_status)">
                                  {{ getPaymentStatusLabel(payment.payment_status) }}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div *ngIf="paymentHistory.length === 0" class="text-muted">
                        Keine Zahlungshistorie verfügbar
                      </div>
                    </div>

                    <div class="col-12 col-lg-6">
                      <h5>Zahlungsanalyse</h5>
                      <div class="card">
                        <div class="card-body">
                          <div class="row">
                            <div class="col-6">
                              <strong>Gezahlter Betrag:</strong>
                            </div>
                            <div class="col-6">
                              {{ formatCurrency(frmZahlung.get('betrag')?.value || 0) }}
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-6">
                              <strong>Fälliger Betrag:</strong>
                            </div>
                            <div class="col-6">
                              {{ formatCurrency(frmZahlung.get('mandat_betrag_faellig')?.value || 0) }}
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-6">
                              <strong>Differenz:</strong>
                            </div>
                            <div class="col-6">
                              <span [class]="(frmZahlung.get('betrag_differenz')?.value || 0) > 0 ? 'text-success' : (frmZahlung.get('betrag_differenz')?.value || 0) < 0 ? 'text-danger' : 'text-muted'">
                                {{ formatCurrency(frmZahlung.get('betrag_differenz')?.value || 0) }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Mandats-Journal (Kontoauszug / Buchungsjournal) -->
                  <div class="row mt-4">
                    <div class="col-12">
                      <h5 class="d-flex align-items-center gap-2">
                        Mandats-Journal
                        <span *ngIf="zahlung?.aktenzeichen" class="badge bg-info">Aktenzeichen: {{ zahlung?.aktenzeichen }}</span>
                      </h5>
                      <p class="text-muted" style="font-size: 0.85rem">
                        Vollständiger Verlauf des Mandats – ausgestellt, erfasst, kontrolliert, fällig, via VSTV übermittelt,
                        bezahlt, retourniert usw. (verknüpft über das Aktenzeichen).
                      </p>
                      <div class="table-responsive" *ngIf="lifecycle.length > 0">
                        <table class="table table-sm table-striped table-bordered align-middle mb-0">
                          <thead class="table-light">
                            <tr>
                              <th style="width: 150px">Datum / Zeit</th>
                              <th style="width: 200px">Aktion</th>
                              <th>Information</th>
                              <th style="width: 120px">Kategorie</th>
                              <th style="width: 150px">Benutzer</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let entry of lifecycle">
                              <td class="text-nowrap">{{ formatDateTime(entry.created) }}</td>
                              <td class="fw-bold">{{ entry.aktion }}</td>
                              <td>{{ entry.info }}</td>
                              <td>
                                <span class="badge bg-secondary" *ngIf="entry.category">{{ entry.category }}</span>
                              </td>
                              <td>{{ entry.dienstname || entry.userid }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div *ngIf="lifecycle.length === 0" class="text-muted">
                        Kein Journal-Verlauf für dieses Mandat verfügbar.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mat-tab>

            <!-- Tab 4: Return Processing -->
            <mat-tab label="Rücküberweisung">
              <div class="step-container d-flex align-items-start flex-column">
                <div class="container-fluid mt-6">
                  <div class="form">
                    <div class="row">
                      <div class="col-12">
                        <div class="alert alert-info">
                          <h6>Rücküberweisung verarbeiten</h6>
                          <p>Hier können Überzahlungen oder Doppelzahlungen für eine Rücküberweisung markiert werden.</p>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-lg-6">
                        <!-- Return Reason -->
                        <div class="form-group">
                          <label class="form-label" for="processing_notes">Rücküberweisungsgrund</label>
                          <textarea
                            class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                            id="processing_notes"
                            formControlName="processing_notes"
                            rows="4"
                            placeholder="Grund für die Rücküberweisung..."></textarea>
                        </div>

                        <!-- Remarks -->
                        <div class="form-group">
                          <label class="form-label" for="bemerkungen">Bemerkungen</label>
                          <textarea
                            class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                            id="bemerkungen"
                            formControlName="bemerkungen"
                            rows="3"
                            placeholder="Zusätzliche Bemerkungen..."></textarea>
                        </div>
                      </div>

                      <div class="col-12 col-lg-6">
                        <!-- File Upload -->
                        <div class="form-group">
                          <label class="form-label">Belege hochladen</label>
                          <input
                            type="file"
                            class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                            #fileInput
                            (change)="onFileUpload($event)"
                            multiple
                            accept="image/*,.pdf" />
                          <small class="form-text text-muted">
                            Erlaubte Formate: JPG, PNG, GIF, PDF (max. 10MB)
                          </small>
                        </div>

                        <!-- Uploaded Files -->
                        <div class="form-group" *ngIf="uploadedFiles.length > 0">
                          <label class="form-label">Hochgeladene Dateien</label>
                          <div class="list-group">
                            <div *ngFor="let file of uploadedFiles" class="list-group-item">
                              <div class="d-flex justify-content-between align-items-center">
                                <span>{{ file.name }}</span>
                                <button type="button" class="btn btn-sm btn-outline-danger">
                                  <i class="fas fa-trash"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Aktionen Rücküberweisung -->
                    <div class="row mt-3">
                      <div class="col-12">
                        <div *ngIf="zahlung?.reconciliation_status === 'R'" class="alert alert-warning">
                          <i class="fas fa-undo-alt"></i> Diese Zahlung ist bereits zur Rücküberweisung markiert.
                        </div>
                        <button type="button"
                                class="inline-flex items-center gap-2 rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50"
                                (click)="exportRetour()"
                                [disabled]="!zahlung?.id || isExportingRetour">
                          <i class="fas fa-file-export"></i>
                          {{ isExportingRetour ? 'Export läuft...' : 'Export' }}
                        </button>
                        <p class="mt-2 text-sm text-gray-500">
                          Erzeugt eine einzelne camt.054-Datei für diese Zahlung und lädt sie als
                          <span class="font-mono">&lt;Aktenzeichen&gt;_&lt;Kontoname&gt;.xml</span> herunter.
                          Die Zahlung wird dabei zur Rücküberweisung markiert.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>

          <!-- Form Actions -->
          <div class="form-actions mt-4">
            <div class="d-flex justify-content-between">
              <button type="button" class="btn btn-secondary" (click)="cancelEdit()">
                <i class="fas fa-times"></i> Abbrechen
              </button>
              <div>
                <button type="button" class="btn btn-outline-primary me-2" (click)="saveZahlung(false)" 
                        [disabled]="!isFormValid || isSaving">
                  <i class="fas fa-save"></i> Speichern
                </button>
                <button type="submit" class="btn btn-primary" [disabled]="!isFormValid || isSaving">
                  <i class="fas fa-check"></i> Speichern & Schließen
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Mandat-Vorschau Modal -->
<div *ngIf="showMandatePreview" class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
     (click)="closeMandatePreview()">
  <div class="max-h-[90vh] w-full max-w-3xl overflow-y-auto rounded-lg bg-white shadow-xl" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="flex items-start justify-between border-b border-gray-200 px-5 py-4">
      <div>
        <h3 class="text-lg font-semibold text-gray-800">
          Mandat {{ previewMandat?.Md_BelegNr }}
        </h3>
        <span class="mt-1 inline-flex rounded-full px-2 py-0.5 text-xs font-medium"
              [ngClass]="getMandatStatusClass(previewMandat?.Md_Status)">
          {{ getMandatStatusLabel(previewMandat?.Md_Status) }}
        </span>
      </div>
      <button type="button" (click)="closeMandatePreview()" class="text-gray-400 hover:text-gray-600">
        <i class="fas fa-times text-xl"></i>
      </button>
    </div>

    <div class="px-5 py-4">
      <!-- Warnung -->
      <div *ngIf="isMandatWarning(previewMandat?.Md_Status)"
           class="mb-4 flex items-start gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-800">
        <i class="fas fa-exclamation-triangle mt-0.5"></i>
        <span>{{ getMandatWarningText(previewMandat?.Md_Status) }}</span>
      </div>

      <!-- Mandatsdaten -->
      <dl class="grid grid-cols-1 gap-x-6 gap-y-2 text-sm sm:grid-cols-2">
        <div class="flex justify-between border-b border-gray-100 py-1">
          <dt class="text-gray-500">Kennzeichen</dt>
          <dd class="font-medium text-gray-800">{{ previewMandat?.Md_Kennzeichen }}</dd>
        </div>
        <div class="flex justify-between border-b border-gray-100 py-1">
          <dt class="text-gray-500">Betrag</dt>
          <dd class="font-medium text-gray-800">{{ formatCurrency(previewMandat?.Md_Betrag || 0) }}</dd>
        </div>
        <div class="flex justify-between border-b border-gray-100 py-1">
          <dt class="text-gray-500">Tatdatum</dt>
          <dd class="font-medium text-gray-800">{{ formatDate(previewMandat?.Md_Datum || '') }} {{ previewMandat?.Md_ZeitVon }}</dd>
        </div>
        <div class="flex justify-between border-b border-gray-100 py-1">
          <dt class="text-gray-500">Ort</dt>
          <dd class="font-medium text-gray-800">{{ previewMandat?.Md_Strasse }} {{ previewMandat?.Md_HausNr }}</dd>
        </div>
        <div class="flex justify-between border-b border-gray-100 py-1">
          <dt class="text-gray-500">Status seit</dt>
          <dd class="font-medium text-gray-800">{{ formatDate(previewMandat?.Md_StatusDate || '') }} {{ previewMandat?.Md_StatusTime }}</dd>
        </div>
        <div class="flex justify-between border-b border-gray-100 py-1">
          <dt class="text-gray-500">VSTV</dt>
          <dd class="font-medium text-gray-800">
            <span *ngIf="previewMandat?.vstv_export">exportiert (Paket {{ previewMandat?.vstv_packet }})</span>
            <span *ngIf="!previewMandat?.vstv_export">nicht exportiert</span>
          </dd>
        </div>
        <div class="col-span-1 flex justify-between border-b border-gray-100 py-1 sm:col-span-2" *ngIf="previewMandat?.notes">
          <dt class="text-gray-500">Notizen</dt>
          <dd class="font-medium text-gray-800">{{ previewMandat?.notes }}</dd>
        </div>
      </dl>

      <!-- Journal / Kontoauszug -->
      <h4 class="mt-5 mb-2 text-sm font-semibold text-gray-700">Journal / Verlauf</h4>
      <div *ngIf="isLoadingPreviewJournal" class="py-3 text-center text-sm text-gray-500">
        Journal wird geladen...
      </div>
      <div *ngIf="!isLoadingPreviewJournal" class="overflow-x-auto rounded-md border border-gray-200">
        <table class="min-w-full divide-y divide-gray-200 text-sm">
          <thead class="bg-gray-100">
            <tr>
              <th class="px-3 py-2 text-left font-medium text-gray-600">Datum / Zeit</th>
              <th class="px-3 py-2 text-left font-medium text-gray-600">Aktion</th>
              <th class="px-3 py-2 text-left font-medium text-gray-600">Information</th>
              <th class="px-3 py-2 text-left font-medium text-gray-600">Benutzer</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100">
            <tr *ngFor="let entry of previewJournal">
              <td class="whitespace-nowrap px-3 py-2 text-gray-700">{{ formatDateTime(entry.created) }}</td>
              <td class="px-3 py-2 font-medium text-gray-800">{{ entry.aktion }}</td>
              <td class="px-3 py-2 text-gray-700">{{ entry.info }}</td>
              <td class="px-3 py-2 text-gray-700">{{ entry.dienstname || entry.userid }}</td>
            </tr>
            <tr *ngIf="previewJournal.length === 0">
              <td colspan="4" class="px-3 py-4 text-center text-gray-500">Kein Journal-Verlauf vorhanden.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Footer -->
    <div class="flex justify-end gap-2 border-t border-gray-200 px-5 py-4">
      <button type="button" (click)="closeMandatePreview()"
              class="rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100">
        Schließen
      </button>
      <button type="button" (click)="selectFromPreview()"
              class="rounded-md bg-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-green-700">
        <i class="fas fa-check"></i> Dieses Mandat auswählen
      </button>
    </div>
  </div>
</div>

